<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reloadAndClear"
      @openEditDialog="openEditDialog"
      @openEditNcDialog="openEditNcDialog"
      @purchasableApplyApi="purchasableApprovedApi"
      @return="returnApp"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
          v-if="allow('E')"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('E')"
            :disabled="!checkedRowCount"
            @click="openChooiseTemplate"
          >
            {{ $l('btn_export_nc') || '导出NC赋码文件' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>

        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
          v-if="allow('A')"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-primary"
            v-if="allow('A')"
            :disabled="!checkedRowCount"
            @click="purchasableApply"
          >
            {{ $l('btn_confirmation_success') || '批量转正式产品' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('U')"
            :disabled="!checkedRowCount"
            @click="updateSpecSize"
          >
            {{ $l('btn_batch_update_spec') || '批量更新箱规尺寸' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('C')"
            :disabled="!checkedRowCount"
            @click="updateCustoms"
          >
            {{ $l('btn_update_of_customs') || '批量更新报关信息' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('K')"
            :disabled="!checkedRowCount"
            @click="updateMaterialInfo"
          >
            {{ $l('btn_batch_update_materialInfo') || '批量更新材料' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
          v-if="allow('R')"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-danger"
            v-if="allow('R')"
            :disabled="!checkedRowCount"
            @click="returnApplication"
          >
            {{ $l('btn_return_application') || '退回申请' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <SkuDetail
      v-if="skuDetailOpts.visible"
      :type="skuDetailOpts.type"
      :disabled="skuDetailOpts.disabled"
      :visible.sync="skuDetailOpts.visible"
      :evgSkuCode="skuDetailOpts.evgSkuCode"
      :applicationStatus="skuDetailOpts.applicationStatus"
      @reload="reloadAndClear"
    />

    <EditEvgNc
      :visible.sync="editEvgNcOpts.visible"
      :disabled="editEvgNcOpts.disabled"
      :title="editEvgNcOpts.title"
      :evgSkuCode="editEvgNcOpts.evgSkuCode"
      @reload="reloadAndClear"
    />
    <SpecSize
      :visible="showSpecSize"
      v-if="showSpecSize"
      @close="showSpecSize = false"
      @saveSpecSize="saveSpecSize"
    />
    <Customs
      :visible="showCustoms"
      v-if="showCustoms"
      @close="showCustoms = false"
      @saveCustoms="saveCustoms"
    />
    <MaterialInfo
      :visible="showMaterialInfo"
      :detailCategoryCode="detailCategoryCode"
      v-if="showMaterialInfo"
      @close="showMaterialInfo = false"
      @saveMaterialInfo="saveMaterialInfo"
    />
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import SkuDetail from '../detail'
import EditEvgNc from '../edit-evg-nc'
import SpecSize from '../spec-size'
import Customs from '../customs'
import MaterialInfo from '../material-info'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import chooseTemplate from '@/views/ecom/components/choose-template'
import { mapState } from 'vuex'

export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    SkuDetail,
    chooseTemplate,
    EditEvgNc,
    SpecSize,
    Customs,
    MaterialInfo,
  },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      skuDetailOpts: {
        visible: false,
        disabled: false,
        type: '',
        evgSkuCode: '',
        applicationStatus: '',
      },
      showSpecSize: false,
      showCustoms: false,
      showMaterialInfo: false,
      editEvgNcOpts: {
        visible: false,
        evgSkuCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'ecom-evgNcExport',
        searchForm: {},
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
    ...mapState('admin/user', ['info']),
  },
  methods: {
    openChooiseTemplate() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_select_sku') || '请选择需要SKU',
          type: 'warning',
        })
        return
      }
      this.chooseTemplateOptions.searchForm = {}
      const { userName } = this.info
      const listEvgSkuCode = this.checkedRows.map((item) => item.evgSkuCode)
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm.codes = listEvgSkuCode
      this.chooseTemplateOptions.searchForm.userName = userName
    },
    purchasableApply() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_select_sku') || '请选择需要SKU',
          type: 'warning',
        })
        return
      }
      const listEvgSkuCode = this.checkedRows.map((item) => item.evgSkuCode)
      this.purchasableApprovedApi(listEvgSkuCode)
    },
    getData(form) {
      this.loading = true
      this.$api
        .ecomEvgSkuPlaceListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async purchasableApprovedApi(listEvgSkuCode) {
      const confirm = await this.$confirm(
        this.$l('tips_palce_Confirmation') || '是否转正式产品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuFullMemberApi({ listEvgSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_confirmation_failed') || '转正失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_confirmation_success') || '转正成功！',
        type: 'success',
      })
      this.reloadAndClear()
    },
    openEditDialog({ type, data = {} } = {}) {
      const { evgSkuCode, applicationStatus } = data
      const disabled = type == 'detail'
      this.skuDetailOpts = {
        visible: true,
        type,
        disabled,
        evgSkuCode,
        applicationStatus,
      }
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    returnApp(listEvgSkuCode) {
      this.$prompt(
        this.$l('tips_information_review') || '是否要审核驳回？',
        this.$l('tips_information_review_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_review_confirm') || '确定',
          cancelButtonText: this.$l('btn_review_cancel') || '取消',
          inputPlaceholder:
            this.$l('placeholder_review_input') || '请输入驳回原因',
          inputType: 'textarea',
          inputValidator: (value) => {
            if (value) {
              return true
            }
            return this.$l('validator_review_input') || '请输入驳回原因'
          },
          inputErrorMessage:
            this.$l('error_message_review_input') || '请输入驳回原因',
        }
      )
        .then(({ value }) => {
          if (this.loadingOpen()) return
          this.$api
            .ecomEvgSkuReturnApplicationApi({
              listEvgSkuCode: listEvgSkuCode,
              rejectReason: value,
            })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status == 200) {
                this.$message({
                  showClose: true,
                  message: this.$l('tips_return_success') || '退回成功！',
                  type: 'success',
                })
              }
              this.reloadAndClear()
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
    async returnApplication() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_select_sku') || '请选择SKU',
          type: 'warning',
        })
        return
      }
      const listEvgSkuCode = this.checkedRows.map((item) => item.evgSkuCode)
      this.returnApp(listEvgSkuCode)
    },

    reloadAndClear() {
      this.clearCheckboxRow()
      this.reload()
    },

    openEditNcDialog({ type, data = {} } = {}) {
      const types = {
        edit: this.$l('form_label_ProductNCcoding') || '产品NC赋码',
      }
      const { evgSkuCode } = data
      this.editEvgNcOpts = {
        visible: true,
        title: types[type],
        evgSkuCode: evgSkuCode,
        disabled: type === 'detail',
      }
    },
    updateSpecSize() {
      this.showSpecSize = true
    },
    updateCustoms() {
      this.showCustoms = true
    },
    updateMaterialInfo() {
      const checkedSpu = Array.from(
        new Set(this.checkedRows.map((e) => e.evgSpuCode))
      )
      if (checkedSpu.length > 1) {
        this.$message({
          message: this.$l('tips_select_spu_too_many') || '存在不同的SPU',
          type: 'warning',
        })
        return
      }
      this.showMaterialInfo = true
    },
    async saveMaterialInfo(params) {
      const evgSkuCodes = this.checkedRows.map((item) => item.evgSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuMaterialInfoApi({ ...params, evgSkuCodes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showMaterialInfo = false
      this.reloadAndClear()
    },
    async saveSpecSize(params) {
      const evgSkuCodes = this.checkedRows.map((item) => item.evgSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuUpdateSizeApi({ ...params, evgSkuCodes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showSpecSize = false
      this.reloadAndClear()
    },
    async saveCustoms(params) {
      const evgSkuCodes = this.checkedRows.map((item) => item.evgSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuCustomsApi({ ...params, evgSkuCodes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showCustoms = false
      this.reloadAndClear()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
